import * as React from "react"

function InvaderAlert(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 600 350" {...props}>
      <style>
        {
          ".invader-alert_st3{fill:#fff}.invader-alert_st4{fill:#e9ecef}.invader-alert_st5{fill:#00aeef}.invader-alert_st6{fill:#c1c6cb}.invader-alert_st15{fill:#c8d916}.invader-alert_st16{fill:#77c433}"
        }
      </style>
      <g id="invader-alert_Guides_and_Back">
        <path
          d="M469.6 273.7c-107.6 84.4-283.7 88.2-382.7-4.3-50.3-47-96.4-133.7-67.8-177.7 32.2-49.5 126.6 4.5 312.3-20.9 151.1-20.6 210.2-73 239.8-42.1 37.6 39.3-10.4 173.5-101.6 245z"
          fill="#7c8bdf"
        />
        <path className="invader-alert_st3" d="M50 50h500v250H50z" />
      </g>
      <g id="invader-alert_Page_Content">
        <path
          className="invader-alert_st4"
          d="M86 281.5c-1.9 0-3.5-1.6-3.5-3.5V107c0-1.9 1.6-3.5 3.5-3.5h428c1.9 0 3.5 1.6 3.5 3.5v171c0 1.9-1.6 3.5-3.5 3.5H86z"
        />
        <path
          className="invader-alert_st4"
          d="M514 104c1.7 0 3 1.3 3 3v171c0 1.7-1.3 3-3 3H86c-1.7 0-3-1.3-3-3V107c0-1.7 1.3-3 3-3h428m0-1H86c-2.2 0-4 1.8-4 4v171c0 2.2 1.8 4 4 4h428c2.2 0 4-1.8 4-4V107c0-2.2-1.8-4-4-4z"
        />
        <path
          className="invader-alert_st3"
          d="M86 92.7c-2 0-3.7-1.7-3.7-3.7V72c0-2 1.7-3.7 3.7-3.7h210.5v24.5H86z"
        />
        <path
          className="invader-alert_st5"
          d="M296 68.7v23.5H86c-1.8 0-3.2-1.4-3.2-3.2V72c0-1.8 1.4-3.2 3.2-3.2h210m1-1.1H86c-2.3 0-4.2 1.9-4.2 4.2v17c0 2.3 1.9 4.2 4.2 4.2h211V67.7zM297 67.7h216.8c2.3 0 4.2 1.9 4.2 4.2v17c0 2.3-1.9 4.2-4.2 4.2H297V67.7z"
        />
        <path className="invader-alert_st5" d="M160 76h42v9h-42z" />
        <path
          className="invader-alert_st6"
          d="M308 112h42v9h-42zM308 130h98v9h-98zM308 144h98v9h-98zM308 158h58v9h-58z"
        />
        <path
          className="invader-alert_st3"
          d="M388 76h42v9h-42zM149.8 167H94.2c-2.2 0-4-1.8-4-4v-47.6c0-2.2 1.8-4 4-4h55.5c2.2 0 4 1.8 4 4V163c.1 2.2-1.7 4-3.9 4zM509 282H90.2v-92.6c0-2.2 1.8-4 4-4H505c2.2 0 4 1.8 4 4V282z"
        />
        <path
          className="invader-alert_st5"
          d="M138.5 127.1h-33.4c-.9 0-1.5-.7-1.5-1.5V118c0-.9.7-1.5 1.5-1.5h33.4c.8 0 1.5.7 1.5 1.5v7.5c.1.9-.6 1.6-1.5 1.6z"
        />
        <path className="invader-alert_st6" d="M111.3 139.2H132V153h-20.7z" />
        <path
          className="invader-alert_st3"
          d="M220.4 167h-55.5c-2.2 0-4-1.8-4-4v-47.6c0-2.2 1.8-4 4-4h55.5c2.2 0 4 1.8 4 4V163c0 2.2-1.8 4-4 4z"
        />
        <path
          d="M209.2 127.1h-33.4c-.9 0-1.5-.7-1.5-1.5V118c0-.9.7-1.5 1.5-1.5h33.4c.8 0 1.5.7 1.5 1.5v7.5c0 .9-.7 1.6-1.5 1.6z"
          fill="#1eca8a"
        />
        <path className="invader-alert_st6" d="M181.9 139.2h20.7V153h-20.7z" />
        <path
          className="invader-alert_st3"
          d="M291 167h-55.5c-2.2 0-4-1.8-4-4v-47.6c0-2.2 1.8-4 4-4H291c2.2 0 4 1.8 4 4V163c0 2.2-1.8 4-4 4z"
        />
        <path
          d="M279.8 127.1h-33.4c-.9 0-1.5-.7-1.5-1.5V118c0-.9.7-1.5 1.5-1.5h33.4c.8 0 1.5.7 1.5 1.5v7.5c0 .9-.7 1.6-1.5 1.6z"
          fill="#efc621"
        />
        <path className="invader-alert_st6" d="M252.5 139.2h20.7V153h-20.7z" />
        <path
          d="M460.7 173c-6-.2-12.2-2.3-17.6-6.7-4.3-3.4-7.4-7.7-9.3-12.8-.3-.7-.1-.9.5-1.1 2.6-.8 5.2-1.6 7.8-2.5.6-.2.8-.2 1 .5 2.9 7.1 8.2 11.4 15.7 12.6 6.3 1 12-.6 16.7-5 4.2-3.9 6.6-8.7 6.6-14.4 0-7.6-3.2-13.6-9.7-17.7-2.8-1.8-5.9-2.7-9.3-2.9-.6 0-.9-.2-.9-.9v-8.2c0-.7.3-.8.9-.8 6.5.3 12.2 2.4 17.3 6.5 3.7 2.9 6.6 6.6 8.6 10.9 2.7 5.9 3.5 12 2.3 18.3-1.7 8.6-6.4 15.2-13.7 19.9-4.5 2.8-10.2 4.3-16.9 4.3z"
          fill="#1891f7"
        />
        <path
          d="M449.7 127c-.2.1-.4.2-.6.4-2.8 2.2-4.8 5-6 8.3-.2.4-.3.6-.9.5-2.7-.9-5.4-1.8-8.2-2.6-.6-.2-.5-.5-.3-.9 1.1-3.3 2.9-6.2 5.1-8.9 1.4-1.6 2.9-3.1 4.6-4.4.3-.3.5-.5.9 0 1.7 2.4 3.5 4.7 5.2 7.1 0 .1 0 .2.2.5z"
          fill="#fbae33"
        />
        <path
          d="M431.8 143c.1-2.9.5-5.5 1.2-8.1.2-.7.4-.8 1.1-.6 2.6.9 5.2 1.7 7.8 2.5.7.2.8.5.6 1.1-.9 3.4-.9 6.7 0 10.1.1.4.2.8-.4 1-2.7.8-5.4 1.7-8.1 2.6-.5.2-.7.2-.9-.4-.9-2.8-1.3-5.6-1.3-8.2z"
          fill="#25e197"
        />
        <path
          d="M461.5 117.9v4.1c0 .6-.1.8-.8.9-3.6.2-6.9 1.2-9.9 3.2-.3.2-.5.4-.8 0-1.7-2.4-3.4-4.7-5.1-7-.3-.5-.2-.7.2-.9 4.7-3.2 9.9-4.8 15.6-5.1.7 0 .8.2.8.8-.1 1.3 0 2.7 0 4z"
          fill="#fc4863"
        />
        <path
          className="invader-alert_st4"
          d="M89.9 263.1H509V282H89.9zM89.9 212.1H509V237H89.9z"
        />
        <path
          className="invader-alert_st6"
          d="M113.7 195.2h26.5v8.6h-26.5zM324.1 195.2h26.5v8.6h-26.5zM386.8 195.2h38.3v8.6h-38.3zM455.9 195.2h38.3v8.6h-38.3zM170.9 195.2h53.9v8.6h-53.9zM113.7 220.7h32.5v8.6h-32.5zM324.1 220.7h31.6v8.6h-31.6zM170.9 220.7H298v8.6H170.9zM113.7 271.9h23v8.6h-23zM324.1 271.9h31.6v8.6h-31.6zM170.9 271.9h131.9v8.6H170.9zM113.7 246.2h32.5v8.6h-32.5zM324.1 246.2h31.6v8.6h-31.6zM170.9 246.2h120.3v8.6H170.9zM104.8 249.5h-2.9v-3c0-.4-.3-.7-.7-.7h-.7c-.4 0-.7.3-.7.7v3H97c-.4 0-.7.3-.7.7v.7c0 .4.3.7.7.7h2.9v3c0 .4.3.7.7.7h.7c.4 0 .7-.3.7-.7v-3h2.9c.4 0 .7-.3.7-.7v-.7c-.2-.4-.4-.7-.8-.7zM104.8 275.5h-2.9v-3c0-.4-.3-.7-.7-.7h-.7c-.4 0-.7.3-.7.7v3H97c-.4 0-.7.3-.7.7v.7c0 .4.3.7.7.7h2.9v3c0 .4.3.7.7.7h.7c.4 0 .7-.3.7-.7v-3h2.9c.4 0 .7-.3.7-.7v-.7c-.2-.4-.4-.7-.8-.7zM104.8 224h-2.9v-3c0-.4-.3-.7-.7-.7h-.7c-.4 0-.7.3-.7.7v3H97c-.4 0-.7.3-.7.7v.7c0 .4.3.7.7.7h2.9v3c0 .4.3.7.7.7h.7c.4 0 .7-.3.7-.7v-3h2.9c.4 0 .7-.3.7-.7v-.7c-.2-.4-.4-.7-.8-.7z"
        />
        <path
          d="M481.5 229.6h-13.1c-.9 0-1.4-.7-1.4-1.5v-7.5c0-.9.7-1.5 1.4-1.5h13.1c.8 0 1.4.7 1.4 1.5v7.5c.2.8-.5 1.5-1.4 1.5z"
          fill="#ed752b"
        />
        <path
          d="M481.5 255.9h-13.1c-.9 0-1.4-.7-1.4-1.5v-7.5c0-.9.7-1.5 1.4-1.5h13.1c.8 0 1.4.7 1.4 1.5v7.5c.2.8-.5 1.5-1.4 1.5z"
          fill="#f0b922"
        />
        <path
          className="invader-alert_st15"
          d="M481.5 281.5h-13.1c-.9 0-1.4-.7-1.4-1.5v-7.5c0-.9.7-1.5 1.4-1.5h13.1c.8 0 1.4.7 1.4 1.5v7.5c.2.8-.5 1.5-1.4 1.5z"
        />
        <g>
          <path
            className="invader-alert_st15"
            d="M412.9 255.7h-13.6c-.9 0-1.5-.7-1.5-1.5v-7.5c0-.9.7-1.5 1.5-1.5h13.6c.8 0 1.5.7 1.5 1.5v7.5c.1.8-.6 1.5-1.5 1.5z"
          />
        </g>
        <g>
          <path
            className="invader-alert_st16"
            d="M412.9 281.2h-13.6c-.9 0-1.5-.7-1.5-1.5v-7.5c0-.9.7-1.5 1.5-1.5h13.6c.8 0 1.5.7 1.5 1.5v7.5c.1.8-.6 1.5-1.5 1.5z"
          />
        </g>
        <g>
          <path
            className="invader-alert_st16"
            d="M412.9 230.2h-13.6c-.9 0-1.5-.7-1.5-1.5v-7.5c0-.9.7-1.5 1.5-1.5h13.6c.8 0 1.5.7 1.5 1.5v7.5c.1.8-.6 1.5-1.5 1.5z"
          />
        </g>
      </g>
    </svg>
  )
}

export default InvaderAlert
